// How a piece of media is gated for listeners/viewers. New media defaults to
// SUBSCRIPTION (unlocked for any active subscriber); admins can switch an item
// to a one-time PURCHASE or make it FREE from the create/edit form.
import type { PurchaseOption } from '../types/api';

export const DEFAULT_PURCHASE_OPTION: PurchaseOption = 'SUBSCRIPTION';

export interface PurchaseOptionDef {
  value: PurchaseOption;
  label: string;
  hint: string;
}

export const PURCHASE_OPTIONS: PurchaseOptionDef[] = [
  { value: 'SUBSCRIPTION', label: 'Subscription',      hint: 'Unlocked for any active subscriber.' },
  { value: 'PURCHASE',     label: 'One-time purchase',  hint: 'Bought individually from the store.' },
  { value: 'FREE',         label: 'Free',               hint: 'Open to everyone — no paywall.' },
];

export function purchaseOptionLabel(value?: string): string {
  return PURCHASE_OPTIONS.find(o => o.value === value)?.label || 'Subscription';
}
